
export default{
    //保存用户信息
    saveInfo({commit}, {userName,roleId,roleName,realName,roleType}) {
        commit('setUserName', userName);
        commit('setName', realName);
        commit('setRoleId', roleId); 
        commit('setRoleName', roleName);
        commit('setRoleType', roleType);
    },
    //保存面包屑
    saveCrumbs({commit},crumbsArr){
        commit('setCrumbsArr', crumbsArr);
    },
    //储存跳转路由
    saveJumpMenu({commit},JumpMenu){
        commit('setJumpMenu', JumpMenu);
    },
    //储存菜单列表
    saveMenu({commit},menu){
        commit('setMenu', menu);
    },
    //储存菜单ur;
    saveLogUrl({commit},logUrl){
        commit('setLogUrl', logUrl);
    },
    //获取菜单的width;
    saveMenuWidth({commit},menuWidth){
        commit('setMenuWidth', menuWidth);
    },
    //获取页面的按钮;
    saveButtons({commit},buttons){
        commit('setButtons', buttons);
    },
    //获取tokens;
    saveTokens({commit},tokens){
        commit('setTokens', tokens);
    },
    //Tabs视图
    saveVisitedViews({commit},visitedViews){
        commit('setVisitedViews', visitedViews);
    },
    //缓存
    saveCachedViews({commit},cachedViews){
        commit('setCachedViews', cachedViews);
      },

    //h5pay 卡信息
    saveH5PayCard({commit},H5PayCard){
        commit('setH5PayCard', H5PayCard);
    },
}


// WEBPACK FOOTER //
// ./src/views/store/actions.js